import { useQuery } from '@tanstack/react-query'
import { useOrpcTanstackQueryUtils } from '../orpc'

export function useSubscriptionStatus(options?: { enabled?: boolean }) {
  const orpc = useOrpcTanstackQueryUtils()
  return useQuery({
    ...orpc.subscription.checkSubscription.queryOptions(),
    enabled: options?.enabled ?? true,
  })
}

export function useSubscriptionPurchases(options?: { enabled?: boolean }) {
  const orpc = useOrpcTanstackQueryUtils()
  return useQuery({
    ...orpc.subscription.listPurchases.queryOptions(),
    enabled: options?.enabled ?? true,
  })
}

// The RevenueCat customer-portal URL is a single-use, short-lived token, so
// never serve it from cache: refetch on every mount and treat it as stale
// immediately so callers can `refetch()` right before opening it.
export function useSubscriptionManagementUrl(options?: { enabled?: boolean }) {
  const orpc = useOrpcTanstackQueryUtils()
  return useQuery({
    ...orpc.subscription.getManagementUrl.queryOptions(),
    enabled: options?.enabled ?? true,
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: 'always',
  })
}
